/**
 * Z-Index layer management for consistent layering across the application
 * This helps prevent issues where components appear behind modals or overlays
 */

export const Z_INDEX_LAYERS = {
  // Base application layers
  BASE: 1,
  HEADER: 100,
  HEADER_DROPDOWN: 99,
  SIDEBAR: 200,
  
  // Overlay layers
  MODAL_BACKDROP: 1000,
  MODAL_CONTENT: 1001,
  
  // Components that appear above modals
  DATE_PICKER: 1100,
  DROPDOWN: 1100,
  TOOLTIP: 1200,
  
  // Notification layers
  NOTIFICATION: 1300,
  TOAST: 1400,
  
  // Critical overlays
  LOADING_OVERLAY: 1500,
  ERROR_BOUNDARY: 1600,
  
  // Absolute top layer
  DEBUG_OVERLAY: 9999
} as const;

/**
 * Get z-index for date picker popovers that need to appear above modals
 */
export const getDatePickerZIndex = () => Z_INDEX_LAYERS.DATE_PICKER;

/**
 * Get z-index for modal content
 */
export const getModalZIndex = () => Z_INDEX_LAYERS.MODAL_CONTENT;

/**
 * Get z-index for modal backdrop
 */
export const getModalBackdropZIndex = () => Z_INDEX_LAYERS.MODAL_BACKDROP;

/**
 * Get z-index for notifications
 */
export const getNotificationZIndex = () => Z_INDEX_LAYERS.NOTIFICATION; 